import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画面再表示時の情報取得するサービス
 *
 * @export RegistPastImageService
 * @class RegistPastImageService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistPastImageService extends PlessJsonResponderSub<any> {
  private imageId: string;
  private callerImageId: string;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof RegistPastImageService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPastImageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        PastImage: {
          condition: {
            ImageId: this.imageId,
            CallerImageId: this.callerImageId
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistPastImageService
   */
  execute(imageId: string, callerImageId: string, successFunc: Function = null): void {
    this.imageId = imageId;
    this.callerImageId = callerImageId;
    this.successFunc = successFunc;
    this.send('registPastImage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPastImageService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
